export const contextAccount: { [key: string]: string } = {
  profil: 'EditProfile',
  alert: 'ConfigureAlerts',
};
